import {
  TRANSACTION_FILTER_FIELD_REQUEST,
  TRANSACTION_FILTER_FIELD_REQUEST_SUCCESS,
  TRANSACTION_FILTER_FIELD_REQUEST_FAILURE,
  TRANSACTION_FILTER_FIELD_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const transactionFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_FILTER_FIELD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_FILTER_FIELD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TRANSACTION_FILTER_FIELD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_FILTER_FIELD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default transactionFilterFieldsReducer;
